<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Reports" />
    </div>
    <ReportTable />
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ReportTable from "@/components/incidents/report-table.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "All Incidents",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {};
  },

  components: {
    Layout,
    PageHeader,
    ReportTable,
  },
};
</script>
